module.exports = __webpack_public_path__ + "static/media/email-engagement.a90ccdef.png";